<template>
    <div class="ix-formbuilder-component-summary-content">
        <div class="formbuilder-component boxed" v-if="displayMode == 'readable' || displayMode == 'fillable'">
            <div style="display:flex" class="formbuilder-component-content">
                <div class="formbuilder-component-left">
                    <label :for="index" class="formbuilder-component-label" v-bind:class="{'required' : currentField.required}">{{ currentField.label }}</label>
                    <p class="formbuilder-component-help" v-if="currentField.helper">{{ currentField.helper }}</p>
                </div>

                <div class="formbuilder-component-right" v-if="displayMode == 'readable'">
                    <span style="white-space: pre-line">{{ formatDate(currentField.value) }}</span>
                </div>

                <div class="formbuilder-component-right" v-if="displayMode == 'fillable'" style="width: 100% !important">
                    <v-date-picker v-model="currentField.value" :mode="currentField.format" :timezone="timezone" is24hr :popover="{ visibility: 'click' }">
                        <template v-slot="{ inputValue, inputEvents }">
                            <input
                                class="form-control"
                                :value="inputValue"
                                v-on="inputEvents"
                                :required="currentField.required"
                                :name="index"
                                :id="index"
                            />
                        </template>
                    </v-date-picker>
                </div>

                <div class="clearfix"></div>
            </div>
        </div>

        <div v-if="displayMode == 'summary'" class="ix-formbuilder-component-summary-info">
            <div class="ix-formbuilder-component-summary-handle">
                <span class="ix-drag-icon handle-line"></span>
            </div>
            <div class="ix-formbuilder-component-summary-icon" data-toggle="tooltip" data-placement="top" title="Saisie de date">
                <div class="ix-formbuilder-icon">
                    <i class="far fa-calendar"></i>
                </div>
            </div>
            <div class="ix-formbuilder-component-summary-content">
                <span class="ix-formbuilder-component-summary-label" v-bind:class="{'required': currentField.required}">{{ currentField.label }}</span>
                <span class="ix-formbuilder-component-summary-help" v-if="currentField.helper">{{ currentField.helper }}</span>
                <ul class="ix-formbuilder-component-summary-options">
                    <li>Format : 
                        <span v-if="currentField.format == 'date'">JJ/MM/AAAA</span>
                        <span v-if="currentField.format == 'datetime'">JJ/MM/AAAA HH:MM</span>
                        <span v-if="currentField.format == 'time'">HH:MM</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

    import * as moment from 'moment'

    export default {
        name: "DatepickerComponent",
        props: ['currentField','showIcon','displayMode','index'],
        data() {
            return {
                date: new Date(),
                timezone : '',
            }
        },
        methods : {
            formatDate(value){
                if(value){
                    switch (this.currentField.format) {
                        case 'date':
                            value = moment(value).format('dddd Do MMMM  YYYY')
                            break;
                        case 'datetime':
                            value = moment(value).format('dddd Do MMMM  YYYY, HH:mm')
                            break;
                        case 'time':
                            value = moment(value).format('HH:mm')
                            break;
                        default:
                            return value;
                    }
                } else {
                    value = 'Non renseigné'
                }

                return value
            }
        }

    }
</script>
